// File: src/components/ui/badge.jsx
import React from "react";
import { cn } from "@/lib/utils";

const VARIANT_STYLES = {
  default: "bg-white/10 text-white border border-white/10 hover:bg-white/15",
  yellow:
    "bg-yellow-900/40 text-yellow-200 border border-yellow-500/20 hover:bg-yellow-900/55",
  success:
    "bg-emerald-900/40 text-emerald-200 border border-emerald-500/20 hover:bg-emerald-900/55",
  danger:
    "bg-rose-900/40 text-rose-200 border border-rose-500/20 hover:bg-rose-900/55",
  info: "bg-cyan-900/40 text-cyan-200 border border-cyan-500/20 hover:bg-cyan-900/55",
  outline: "bg-transparent text-white border border-white/20 hover:bg-white/5",
};

const Badge = React.forwardRef(
  ({ children, className = "", variant = "yellow", ...props }, ref) => {
    const variantClass = VARIANT_STYLES[variant] || VARIANT_STYLES.yellow;

    return (
      <span
        ref={ref}
        className={cn(
          "inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium leading-none transition-colors",
          variantClass,
          className
        )}
        {...props}
      >
        {children}
      </span>
    );
  }
);

Badge.displayName = "Badge";

export { Badge };
